import { render, staticRenderFns } from "./HtmlPage.vue?vue&type=template&id=3475cc0c&"
import script from "./HtmlPage.vue?vue&type=script&lang=js&"
export * from "./HtmlPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports